<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import Tweet from '../ui-components/Tweet.svelte';
  import Button from '../common/Button.svelte';
  import ConfirmModal from '../common/ConfirmModal.svelte';
  import Pipe from '../symbols/Pipe.svelte';
  import Common from '../js/common.js';

  export let params;

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let article;
  let tweets = [];

  let loading = true;
  let error;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/articles/get/${params.article}`);

    if (response.ok) {
      const data = await response.json();

      article = data.article;
      tweets = data.tweets;
      user = data.user;

      tweets = Common.sortArrayOfObjectsByKey(tweets, ['timestamp'], true);

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');

      i18n.pageTitle = {
        cs: `${article.title.cs} | ${Global.project.name.cs}`,
        en: `${article.title.en} | ${Global.project.name.en}`,
      };

      i18n.title = {
        cs: article.title.cs,
        en: article.title.en,
      };

      confirmModalMessage = {
        cs: `Opravdu chcete smazat článek "[${Common.addZeros(article.id)}] ${article.code}"?`,
        en: `Do you really want to delete article "[${Common.addZeros(article.id)}] ${article.code}"?`,
      };
    } else {
      if (response.status === Common.NOT_FOUND) window.location.href = './';
      else error = true;
    }

    loading = false;
  })();

  let displayConfirmModal = false;
  let confirmModalMessage = { cs: undefined, en: undefined };
  let messageBox;

  async function deleteArticle () {
    messageBox = {
      cs: { color: 'blue', message: i18n.deletingInProgress.cs },
      en: { color: 'blue', message: i18n.deletingInProgress.en },
    };

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/admin/articles/delete/${value.id}`);

    if (response.ok) {
      window.location.reload();
    } else {
      messageBox = {
        cs: { color: 'red', message: i18n.unexpectedError.cs },
        en: { color: 'red', message: i18n.unexpectedError.en },
      };
    }
  }

  const COLORS = ['grey', 'red', 'purple', 'blue', 'cyan', 'green', 'yellow', 'orange', 'brown'];

  const i18n = {
    pageTitleLoading: {
      cs: `Načítání... | ${Global.project.name.cs}`,
      en: `Loading... | ${Global.project.name.en}`,
    },
    pageTitleError: {
      cs: `Něco se pokazilo | ${Global.project.name.cs}`,
      en: `Something went wrong | ${Global.project.name.en}`,
    },
    notAvailable: {
      cs: 'Tento článek není dostupný v češtině.',
      en: 'This article is not available in English.',
    },
    edit: {
      cs: 'Upravit',
      en: 'Edit',
    },
    delete: {
      cs: 'Smazat',
      en: 'Delete',
    },
    inactive: {
      cs: 'Neaktivní',
      en: 'Inactive',
    },
    deletingInProgress: {
      cs: 'Probíhá mazání článku...',
      en: 'Article deleting in progress...',
    },
    unexpectedError: {
      cs: '(Ne)očekávaná chyba. `E29`',
      en: '(Un)expected error. `E29`',
    },
  };

  let pageTitle;

  $: if (loading) {
    pageTitle = i18n.pageTitleLoading[lang];
  } else if (error) {
    pageTitle = i18n.pageTitleError[lang];
  } else {
    pageTitle = i18n.pageTitle[lang];
  }

  const years = Global.years;
</script>

<svelte:head>
  <title> {pageTitle} </title>
</svelte:head>

<Header page='articles/{params.article}' bind:lang bind:user/>

<Loading bind:display={loading} fullHeight={true}/>
<Error bind:display={error} fullHeight={true} bind:lang/>

{#if !loading && !error}
  <Title img='article/{article.photo ? `${article.code}-${article.photo}` : 'default'}.jpg'
    alt='{article.title.en} article photo' title={i18n.title[lang]} color='red'/>

  <div class='articles-article'>
    <div class='articles-article-box'>
      {#if article.perex[lang] && article.content[lang]}
        <div class='articles-article-box-perex'>
          {@html Common.escapeMarkdown(article.perex[lang])}
        </div>

        <div class='articles-article-box-content'>
          {@html Common.escapeMarkdown(article.content[lang], true)}
        </div>

        <div class='articles-article-box-info'>
          <div class='articles-article-box-info-details'>
            {#if years.length > 1}
              <div class='articles-article-box-info-details-year'
                class:articles-article-box-info-details-year-grey={COLORS[years.indexOf(article.year) % COLORS.length] === 'grey'}
                class:articles-article-box-info-details-year-red={COLORS[years.indexOf(article.year) % COLORS.length] === 'red'}
                class:articles-article-box-info-details-year-purple={COLORS[years.indexOf(article.year) % COLORS.length] === 'purple'}
                class:articles-article-box-info-details-year-blue={COLORS[years.indexOf(article.year) % COLORS.length] === 'blue'}
                class:articles-article-box-info-details-year-cyan={COLORS[years.indexOf(article.year) % COLORS.length] === 'cyan'}
                class:articles-article-box-info-details-year-green={COLORS[years.indexOf(article.year) % COLORS.length] === 'green'}
                class:articles-article-box-info-details-year-yellow={COLORS[years.indexOf(article.year) % COLORS.length] === 'yellow'}
                class:articles-article-box-info-details-year-orange={COLORS[years.indexOf(article.year) % COLORS.length] === 'orange'}
                class:articles-article-box-info-details-year-brown={COLORS[years.indexOf(article.year) % COLORS.length] === 'brown'}>

                {article.year}
              </div>
            {/if}

            {#if user}
              <div class='articles-article-box-info-details-views'> <span class='material-icons'> visibility </span> {article.views} </div>
            {/if}
          </div>

          <div class='articles-article-box-info-author-and-date'>
            {article.author.firstName} {article.author.lastName} <Pipe/> {article.date}
          </div>
        </div>
      {:else}
        <div class='articles-article-box-not-available'>
          {i18n.notAvailable[lang]}
        </div>
      {/if}

      {#if user}
        {#if !article.active}
          <div class='article-article-box-disabled'>
            {i18n.inactive[lang]}
          </div>
        {:else if article.timestamp > Common.getDbDate() + Common.getDbTime()}
          <div class='article-article-box-disabled'>
            {Common.convertDbFullDate(article.timestamp)}
          </div>
        {/if}
      {/if}
    </div>

    <div class='articles-article-right-panel' class:articles-article-right-panel-with-admin={user}>
      <div class='articles-article-right-panel-tweets'>
        {#each tweets as tweet}
          <Tweet value={tweet} dark={true} bind:lang admin={!!user}/>
        {/each}
      </div>

      {#if user}
        <div class='articles-article-right-panel-admin'>
          <Button value={i18n.edit[lang]} icon='edit' dark={true} admin={true}
            onClick={() => { window.location.href = `./#/admin/articles/${article.code}`; }}/>

          <Button value={i18n.delete[lang]} icon='delete' dark={true} admin={true}
            onClick={() => { displayConfirmModal = true; }}/>
        </div>
      {/if}
    </div>
  </div>
{/if}

{#if user}
  <ConfirmModal bind:display={displayConfirmModal} message={confirmModalMessage[lang]}
    onConfirm={deleteArticle} messageBox={messageBox ? messageBox[lang] : undefined} bind:lang/>
{/if}

<Footer bind:lang/>

<style>
  .articles-article {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    max-width: 1440px;

    padding: 40px 60px;

    margin: auto;
  }

  .articles-article-box {
    display: flex;
    flex-direction: column;
    gap: 20px;

    width: calc((100% - 40px) / 3 * 2);
  }

  .articles-article-box-perex {
    font-weight: bold;

    line-height: 1.6;

    overflow-wrap: anywhere;
  }

  .articles-article-box-content {
    line-height: 1.6;

    overflow-wrap: anywhere;
  }

  .articles-article-box-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 22.5px;

    color: var(--grey-7);
  }

  .articles-article-box-info-details {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .articles-article-box-info-details-year {
    display: flex;
    align-items: center;

    height: 22.5px;

    padding: 0px 10px;

    border-radius: 11.25px;

    font-weight: 550;
  }

  .articles-article-box-info-details-year-grey {
    background: var(--grey-1);
    color: var(--grey-8);
  }

  .articles-article-box-info-details-year-red {
    background: var(--red-1);
    color: var(--red-8);
  }

  .articles-article-box-info-details-year-purple {
    background: var(--purple-1);
    color: var(--purple-8);
  }

  .articles-article-box-info-details-year-blue {
    background: var(--blue-1);
    color: var(--blue-8);
  }

  .articles-article-box-info-details-year-cyan {
    background: var(--cyan-1);
    color: var(--cyan-8);
  }

  .articles-article-box-info-details-year-green {
    background: var(--green-1);
    color: var(--green-8);
  }

  .articles-article-box-info-details-year-yellow {
    background: var(--yellow-1);
    color: var(--yellow-8);
  }

  .articles-article-box-info-details-year-orange {
    background: var(--orange-1);
    color: var(--orange-8);
  }

  .articles-article-box-info-details-year-brown {
    background: var(--brown-1);
    color: var(--brown-8);
  }


  .articles-article-box-not-available {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    min-height: max(calc(30vh - 80px), 70px);

    text-align: center;
    text-transform: uppercase;

    letter-spacing: 1.2px;
  }

  .article-article-box-disabled {
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    text-transform: uppercase;

    font-family: 'JetBrains Mono';
    font-weight: bold;

    background: rgba(255, 255, 255, 0.75);
  }

  .articles-article-right-panel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 40px;

    width: calc((100% - 40px) / 3);

    padding: 20px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  .articles-article-right-panel-tweets {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .articles-article-right-panel-admin {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  :global(body.dark) .articles-article-box-info {
    color: var(--grey-5);
  }

  :global(body.dark) .articles-article-box-info-details-year-grey {
    background: var(--grey-8);
    color: var(--grey-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-red {
    background: var(--grey-8);
    color: var(--red-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-purple {
    background: var(--grey-8);
    color: var(--purple-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-blue {
    background: var(--grey-8);
    color: var(--blue-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-cyan {
    background: var(--grey-8);
    color: var(--cyan-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-green {
    background: var(--grey-8);
    color: var(--green-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-yellow {
    background: var(--grey-8);
    color: var(--yellow-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-orange {
    background: var(--grey-8);
    color: var(--orange-3);
  }

  :global(body.dark) .articles-article-box-info-details-year-brown {
    background: var(--grey-8);
    color: var(--brown-3);
  }

  :global(body.dark) .article-article-box-disabled {
    background: rgba(33, 33, 33, 0.75);
  }

  :global(body.dark) .articles-article-right-panel {
    background: var(--grey-8);
  }

  @media only screen and (max-width: 1300px) {
    .articles-article {
      flex-direction: column;
    }

    .articles-article-box {
      width: 100%;
    }

    .articles-article-right-panel {
      display: none;
    }

    .articles-article-right-panel-tweets {
      display: none;
    }

    .articles-article-right-panel-admin {
      flex-direction: row;
    }

    .articles-article-right-panel-with-admin {
      display: flex;

      width: calc(100% - 40px);
    }
  }

  @media only screen and (max-width: 900px) {
    .articles-article {
      padding: 40px;
    }
  }

  @media only screen and (max-width: 750px) {
    .articles-article-right-panel-admin {
      flex-direction: column;
    }
  }

  @media only screen and (max-width: 350px) {
    .articles-article {
      padding: 40px 20px;
    }
  }
</style>
